import { html } from 'lit';
import { api } from '@converse/headless';

function showCreateNewsModal(ev) {
    ev.preventDefault();
    api.modal.show('converse-create-news-modal', {}, ev);
}

export default () => html`<button class="btn btn-primary create-news-btn" @click="${showCreateNewsModal}" title="ایجاد خبر"><i class="fa fa-plus-circle"></i> <span>ایجاد خبر</span></button>`;
